import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { FlexBox } from "@/components/common";
import SearchModeInput from "./SearchModeInput.vue";
import SearchPromptInput from "./SearchPromptInput.vue";

/**
 * Displays a searchbar for generating searches
 * to trace to related artifacts within a project.
 */
const __default__ = {
  name: "ProjectSearchbar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FlexBox), null, {
    default: _withCtx(() => [
      _createVNode(SearchModeInput),
      _createVNode(SearchPromptInput)
    ]),
    _: 1
  }))
}
}

})